import styled from 'styled-components';

export const StyledElections = styled.div`
    padding: 120px 10px;
    font-size: 1.2rem;

    a {
        display: block;
    }
`